import { UntypedFormArray, ValidationErrors, ValidatorFn } from '@angular/forms';

// Only one household can be marked as full time.
// One household must be listed as part time minimally
export function ResidencyValidator(schoolIsNY: boolean): ValidatorFn {
	return (formArray: UntypedFormArray): ValidationErrors | null => {
		// Full time is value of 1
		let fullTimeCount = 0;
		// Part time is value of 2
		let partTimeCount = 0;

		const values = formArray.value;

		if (values && values.length) {
			values.forEach((value: any) => {
				if (value.residencyTypeId === '1') {
					fullTimeCount++;
				} else if (value.residencyTypeId === '2') {
					partTimeCount++;
				}
			});
		}

		if (fullTimeCount > 1) {
			return { fullTimeError: true };
		} else if (fullTimeCount === 0 && partTimeCount === 0 && !schoolIsNY) {
			return { noResidencyError: true };
		} else {
			return null;
		}
	};
}
